module.exports = __webpack_public_path__ + "static/media/power-on.0543cc52.svg";